<template>
  <div>
    <template-drieblok v-if="page.template.template_name === 'Ouders'" :page="page"/>
    <template-standaard v-else :page="page"/>
  </div>
</template>

<script>
import page from '~/plugins/mixins/page';
import TemplateDrieblok from '~/components/templates/TemplateDrieblok';
import TemplateStandaard from '~/components/templates/TemplateStandaard';

export default {
  components: {TemplateStandaard, TemplateDrieblok},
  mixins: [page],
};
</script>
